import { render, staticRenderFns } from "./NewConversationModal.vue?vue&type=template&id=c12c0af6&scoped=true"
import script from "./NewConversationModal.vue?vue&type=script&lang=js"
export * from "./NewConversationModal.vue?vue&type=script&lang=js"
import style0 from "./NewConversationModal.vue?vue&type=style&index=0&id=c12c0af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12c0af6",
  null
  
)

export default component.exports